<template>
  <div :class="[customClasses,{'sidebar-item':variant==1,'sidebar-item-variant-2':variant==2}]">
    <v-list-tile-avatar
      v-on="inputListeners"
      :tile="tile"
      :size="size"
      class="sidebar-avatar"
      :color="color"
      v-if="!hideAvatar"
    >
      <slot name="avatar" />
    </v-list-tile-avatar>
    <v-list-tile-content v-on="inputListeners" class="ml-2" v-if="!hideContent">
      <slot name="content" />
    </v-list-tile-content>
    <v-spacer />
    <v-list-tile-action v-if="action">
      <slot name="action" />
    </v-list-tile-action>
  </div>
</template>
<script>
import {
  VListTileAvatar,
  VListTileContent,
  VListTileAction,
  VSpacer
} from 'vuetify/lib';
export default {
  props: {
    size: {
      type: Number,
      required: false,
      default: 30
    },
    color: {
      type: String,
      required: false,
      default: null
    },
    tile: {
      type: Boolean,
      required: false,
      default: false
    },
    customClasses: {
      type: String,
      required: false,
      default: ''
    },
    action: {
      type: Boolean,
      default: false
    },
    hideAvatar: {
      type: Boolean,
      default: false
    },
    hideContent: {
      type: Boolean,
      default: false
    },
    variant: {
      type: Number,
      default: 1
    }
  },
  components: {
    VListTileAvatar,
    VListTileContent,
    VListTileAction,
    VSpacer
  },
  computed: {
    inputListeners: function () {
      // `Object.assign` merges objects together to form a new object
      return this.$listeners;
    }
  }
};
</script>
<style lang="scss">
.sidebar-avatar {
  justify-content: flex-start !important;
  min-width:56px !important;
  .v-avatar {
    margin: 0 5px !important;
    justify-content: center !important;
    min-width: 56 !important;
    height: 30px !important;
    width: 30px !important;
  }
}
.sidebar-item {
  display: flex;
  align-items: center;
  width:100%;
  .v-list__tile__content {
    max-width: 10rem !important;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .v-list__tile__title{
  max-width: 10rem !important;
  }
  .v-list__tile__action {
    justify-content: flex-end !important;
    min-width: 2rem !important;
  }
}

.sidebar-item-variant-2{
    display: flex;
  align-items: center;
  width:100%;
  .v-list__tile__content {
    max-width: 8rem !important;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .v-list__tile__title{
  max-width: 10rem !important;
  }
  .v-list__tile__action {
    justify-content: flex-end !important;
    min-width: 2rem !important;
  }
}
</style>